import { IonButton, IonIcon, isPlatform, IonSpinner } from '@ionic/react';
import { addOutline, checkmarkCircle, chevronForward } from 'ionicons/icons';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getConfig } from '../../appConfig';
import { NormalText, SmallText, Spacer, StrongText, Subtitle, Title } from '../../components/common';
import Layout from '../../components/layout';
import Loading from '../../components/spinner';
import Basket from '../../lib/basket';
import { withTranslation } from '../../lib/translate';
import { deepCopy, forwardTo, getDefaultRoute, getDistanceUnit, isDefined, isEmptyObject, isTimeAvaibleInMenu, weekdays } from '../../lib/utils';
import location from '../../assets/images/map-pin-filled.svg';
import { getIkentooMenusForLocation, setCommonProp } from '../../store/actions';
import './index.css';
import moment from 'moment';
import { checkSnoozedTimes, isStoreOpened } from '../clickAndCollect';
import { ReactComponent as LocationIcon } from '../../assets/images/distance.svg';
import { ReactComponent as TimeIcon } from '../../assets/images/acute.svg';
import { ReactComponent as TableIcon } from '../../assets/images/picnic-table.svg';
import { ReactComponent as EditIcon } from '../../assets/images/edit-icon.svg';

import Modal from '../../components/modal';
import { ItemDetailsRaw } from '../itemDetails';
import TableNumberModal from '../../components/tableNumberModal';
import OrderList from './orderList';
const defaultModalItemOptions = {
	quantity: 1,
	price: 0,
	selectedChoices: [],
	instructions: '',
};
class OrderPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedCategory: 0,
			ikentooMenu: null,
			originalMenu: null,
			selectedMenu: [],
			searchItemsValue: '',
			searchOpened: false,
			selectRestaurantsModalOpen: false,
			modalOpen: false,
			allergens: [],
			multivenueRestaurantPickerOpened: false,
			menuRefs: null,

		};
	}
	handleAlergens = (allergens) => {
		this.setState({ allergens })
	}
	setIkentooMenu = (updateSelectedCategory) => {
		this.setState(
			{
				ikentooMenu: (isEmptyObject(this.props.ikentooMenu) && isEmptyObject(Basket.getRestaurant())) ? this.props.defaultMenu : this.props.ikentooMenu,
				originalMenu: (isEmptyObject(this.props.ikentooMenu) && isEmptyObject(Basket.getRestaurant())) ? this.props.defaultMenu : this.props.ikentooMenu,
			}, () => {
				let menuRefs = this.menuRefs(this.state.ikentooMenu);
				this.setState({ menuRefs }, () => {
					if (updateSelectedCategory && this.state?.ikentooMenu?.menuEntryGroups?.length > 0) {
						this.selectCategory(this.state.ikentooMenu.menuEntryGroups[0])
					}
				})

			}

		);
		if (this.state.searchItemsValue !== '') {
			this.filterMenuItems(this.state.searchItemsValue);
		}
	};
	componentDidMount() {
		const { scrollTop } = this.props;
		this.setIkentooMenu(true);
		this.setState({
			selectedMenuType: getConfig().menuDisplayType,
		});
		if (this.props.location.state) {
			this.setState({ selectedMenu: this.props.location.state.selectedMenu });
		}
		setTimeout(() => {
			const item = document.querySelector('.order-list-items');
			if (item && !isEmptyObject(this.props.location.state)) {
				item.scrollTop = scrollTop;
				if (!isPlatform('ios')) {
					item.scrollBy({ top: 1 });
				}
			}
		}, 100);

		if (localStorage.getItem('showApplyLoyaltyModal') && getConfig().kiosk.hasLoyalty) {
			this.props.dispatch(setCommonProp('applyLoyaltyModalOpen', true))
			localStorage.removeItem('showApplyLoyaltyModal')

		}
	}

	shouldComponentUpdate(nextProps) {
		const prevMenuName = (Basket.itemsCount() === 0 && isEmptyObject(this.props.ikentooMenu) ? nextProps.defaultMenu : nextProps.ikentooMenu || {}).menuName;
		const currentMenuName = (Basket.itemsCount() === 0 && isEmptyObject(this.props.ikentooMenu) ? this.props.defaultMenu : this.props.ikentooMenu || {}).menuName;
		if (prevMenuName !== currentMenuName || nextProps.restaurantsUpdated !== this.props.restaurantsUpdated) {
			this.setIkentooMenu(true);
		}
		return true;
	}




	backHandler = () => {
		const path = Basket.getDeliveryOption()?.route ?? getDefaultRoute(this.props.navConfig).path;
		forwardTo(path, { saveOrderData: true });
	};
	hideBack = () => {

		return true;
	};

	selectMenu = (index) => {
		const selectedItem = index;
		const currentCategories = this.state.selectedMenu ? [...this.state.selectedMenu] : [];
		currentCategories.push(selectedItem);
		this.setState({ selectedMenu: currentCategories });
	};

	parseCategories = (data) => {
		const { ikentooMenu } = data;
		return !isEmptyObject(ikentooMenu) ? ikentooMenu.menuEntryGroups : [];

	};
	filterMenu(menu) {
		if (menu && menu.menuEntryGroups) {
			menu.menuEntryGroups = this.filterIkentooMenuItems(menu.menuEntryGroups);
			return menu;
		}
		return menu;
	}
	filterIkentooMenuItems(items) {
		let filteredItems = [];
		items.forEach((item) => {
			if (!item.menuEntry) {
				// break recursion when arrive to the product
				if (Basket.getProductName(item, this.props.profile).toLowerCase().includes(`${this.state.searchItemsValue.toLowerCase()}`)) {
					filteredItems.push(item);
					return [item];
				} else {
					return [];
				}
			} else {
				const len = (item.menuEntry || []).length;
				if (len > 0) {
					const newFilteredItems = this.filterIkentooMenuItems(item.menuEntry);
					if (newFilteredItems.length > 0) {
						item.menuEntry = newFilteredItems;
						filteredItems.push(item);
					}
				}
			}
		});

		return filteredItems;
	}
	filterMenuItems = (value) => {
		this.setState({ searchItemsValue: value }, () => {
			const menu = JSON.parse(JSON.stringify(this.state.originalMenu));
			const filtered = this.filterMenu(menu);
			this.setState({ ikentooMenu: filtered })

		});
	};

	formatDayName = (__, name) => {
		if (name.includes('Today')) {
			name = 'Today'.toLowerCase();
		} else if (name.includes('Tomorrow')) {
			name = 'Tomorrow'.toLowerCase();
		} else {
			name = Basket.getOrderDate();
		}
		return name;
	};
	drawContentHeader = (__, deliveryOption, orderType, deliveryAddress) => {
		let dateName = this.formatDayName(
			__,
			moment(Basket.getOrderDate(), 'dddd Do MMMM').calendar(null, {
				sameDay: '[Today]',
				nextDay: '[Tomorrow]',
			}),
		);
		const selectedRestaurant = Basket.getRestaurant();
		if (!isEmptyObject(deliveryOption) && deliveryOption.id === 'pick-up-point') {
			return (
				<div className={`box-content order-header-content ${Basket.has_multi_basket ? 'multi-order-heder-content' : ''}`}>
					<div>
						<LocationIcon fill='fill-label' />
						<StrongText>{Basket.getRestauranName()}</StrongText>
					</div>
				</div>
			);
		} else if (!isEmptyObject(deliveryOption) && deliveryOption.id === 'charter-delivery' && !isEmptyObject(deliveryAddress)) {
			return (
				<div className={`box-content order-header-content ${Basket.has_multi_basket ? 'multi-order-heder-content' : ''}`}>

					{this.props.driverBookingPending ? (
						<>
							<div></div>
							<div>
								<div>
									<div>
										<StrongText>{__('Booking delivery...')}</StrongText>
									</div>
									<Spacer size={0} />
									<SmallText>{__('Allocating an available driver for your order...')}</SmallText>
								</div>
								<div>
									<IonSpinner name={'circular'} style={{ height: '30px', width: '30px' }} />
								</div>
							</div>
						</>
					) : (
						<>
							{this.props.driverBookingMessage ? (
								<>
									<div></div>
									<div>
										<div style={{ display: 'flex', marginRight: 'var(--spacer-2)' }}>
											<IonIcon style={{ height: '25px', width: '25px' }} color="success" icon={checkmarkCircle} />
										</div>
										<div>

											<div>
												<StrongText>{__('Booking delivery...')}</StrongText>
											</div>
											<SmallText>{__('Driver successfully booked')}</SmallText>
										</div>

									</div>
								</>
							) : (
								<>
									<div>
										<LocationIcon fill='fill-label' />
										<StrongText>{deliveryAddress.addressLine1}, {deliveryAddress.place} {deliveryAddress.postalCode}
										</StrongText>
									</div>
									<div>
										<TimeIcon fill='fill-label' />
										<NormalText>
											{dateName}  {Basket.is_asap ? 'ASAP' : `${__('at')} ${Basket.getOrderTime()}`}
										</NormalText>
									</div>

								</>
							)}
						</>
					)}
				</div>
			);
		} else if (!isEmptyObject(deliveryOption) && deliveryOption.id === 'table') {
			return (
				<>

					<div className={`box-content order-header-content ${Basket.has_multi_basket ? 'multi-order-heder-content' : ''}`}>
						<div>
							<LocationIcon fill='fill-label' />{' '}
							<StrongText>{Basket.getRestauranName()}</StrongText>
						</div>
						<div>
							<TableIcon fill='fill-label' />{' '}

							<NormalText>{__('Table number')}</NormalText>
							<NormalText className="bold">{Basket.getTableNumber()}</NormalText>
						</div>
					</div>
				</>

			);
		} else if (!isEmptyObject(deliveryOption) && deliveryOption.id === 'scheduled-collection') {
			return (
				<div className={`box-content order-header-content ${Basket.has_multi_basket ? 'multi-order-heder-content' : ''}`}>
					<div>
						<LocationIcon fill='fill-label' />{' '}
						<StrongText>{Basket.getRestauranName()}</StrongText>
					</div>
					<div>
						<TimeIcon fill='fill-label' />{' '}
						<NormalText>{__('Collection time')}</NormalText>
						<NormalText >
							{Basket.additional_data?.named_time_slots_data ? (
								<>
									{dateName} {'at'} {Basket.additional_data?.named_time_slots_data}
								</>
							) : (
								<>
									{dateName} {'at'} {Basket.getOrderTime('h:mm a')}
								</>
							)}
						</NormalText>
					</div>

				</div>
			);
		} else if (!isEmptyObject(deliveryOption) && deliveryOption.id === 'pick-up-at-counter') {
			return (
				<div className={`box-content order-header-content ${Basket.has_multi_basket ? 'multi-order-heder-content' : ''}`}>
					<div>
						<LocationIcon fill='fill-label' />{' '}
						<StrongText>{Basket.getRestauranName()}</StrongText>
					</div>
					<div>
						<TimeIcon fill='fill-label' />{' '}
						<NormalText>{__('Collection time')}</NormalText>
						<NormalText >{__('ASAP')}</NormalText>
					</div>
				</div>
			);
		} else if (!isEmptyObject(deliveryOption) && deliveryOption.id === 'browse-menu' && selectedRestaurant) {
			return (
				<div className={`box-content order-header-content ${Basket.has_multi_basket ? 'multi-order-heder-content' : ''}`}>
					<div>
						<LocationIcon fill='fill-label' />{' '}

						<StrongText >{selectedRestaurant.name} &nbsp;</StrongText>
						{selectedRestaurant.browse_menu_json_time_selector > 1 ? (
							<div onClick={() => forwardTo(`/browse-menu?bl_id=${selectedRestaurant.business_location_id}`)}>
								<NormalText className="bold link underlined">{`${__('View other menus')}`}</NormalText>
							</div>
						) : null}
					</div>
					<div>
						<NormalText className="block">{__(selectedRestaurant.address)}</NormalText>
					</div>
					{selectedRestaurant?.distance && (
						<div className="distance-wrapper">
							<IonIcon className="location-icon" icon={location}></IonIcon>
							<NormalText className="block bold-description click-collect-small-description">
								{`${parseFloat(selectedRestaurant.distance.toFixed(2)) == 1 ? selectedRestaurant.distance.toFixed(0) : selectedRestaurant.distance.toFixed(2)} ${__(getDistanceUnit(parseFloat(selectedRestaurant.distance.toFixed(2)) == 1))}`}
							</NormalText>
						</div>
					)}
				</div>
			);
		} else if (!isEmptyObject(deliveryOption) && deliveryOption.id === 'scheduled-delivery') {
			return (
				<div className="box-content order-header-content">
					<div>
						<LocationIcon fill='fill-label' />
						<StrongText className="bold">{deliveryAddress.addressLine1}, {deliveryAddress.place} {deliveryAddress.postalCode}</StrongText>
					</div>
					<div>
						<TimeIcon fill='fill-label' />
						<NormalText>{dateName} {__('at')} {Basket.getOrderTime('h:mm a')}</NormalText>
					</div>

				</div>
			);
		} else {
			return (
				<>

					<div className={`box-content order-header-content ${Basket.has_multi_basket ? 'multi-order-heder-content' : ''}`}>
						<div>
							<LocationIcon fill='fill-label' />
							<StrongText>{Basket.getRestauranName()}</StrongText>
							<EditIcon className='fill-label' style={{ margin: 0 }} onClick={() => forwardTo('/click-and-collect', { saveBasket: true })} />
						</div>
						<div>
							<TimeIcon fill='fill-label' />{' '}

							<NormalText>{__('Collection time')}</NormalText>
							<NormalText >{Basket.getOrderTime('h:mm a')}</NormalText>
						</div>
					</div>
				</>

			);
		}
	};
	setCategoryImage = (category) => {
		if (category) {
			if (!category.menuEntry) {
				let image = category.itemRichData?.rawImageUrl;
				if (image && image.indexOf('http://') !== -1) {
					image = image.replace(/http:\/\//g, 'https://');
				}
				return image;
			}
			const item = category.menuEntry.find((el) => el.itemRichData && el.itemRichData.rawImageUrl);
			if (item) {
				let image = item.itemRichData.rawImageUrl;
				if (image && image.indexOf('http://') !== -1) {
					image = image.replace(/http:\/\//g, 'https://');
				}
				return image;
			}
			return this.setCategoryImage(category.menuEntry[0]);
		}
	};
	onSearchHandler = () => {
		this.setState({ searchOpened: !this.state.searchOpened }, () => {
			if (!this.state.searchOpened) {
				this.setState({ selectedMenu: [] }, () => this.filterMenuItems(''))
			} else {
				setTimeout(() => {
					document.querySelector('#products_search').setFocus()
				}, 0);
			}
		});
	};
	selectMultiVenueRestaurant = (restaurant) => {
		this.setState({ selectedMenu: [], multivenueRestaurantPickerOpened: false }, () => {
			Basket.setRestaurant(restaurant);
			if (Basket.order_type == 'kiosk-collection') {
				this.setState({ selectRestaurantsModalOpen: false }, () => {
					this.props.dispatch(
						getIkentooMenusForLocation(restaurant.business_location_id, {
							pickTime: 'asap',
							json_time_selector: restaurant ? restaurant.kiosk_json_time_selector : [],
						}),
					);
				});
			} else if (Basket.order_type == 'kiosk-table') {
				this.setState({ selectRestaurantsModalOpen: false }, () => {
					this.props.dispatch(
						getIkentooMenusForLocation(restaurant.business_location_id, {
							pickTime: 'asap',
							json_time_selector: restaurant ? restaurant.kiosk_table_json_time_selector : [],
						}),
					);
				});
			} else if (Basket.order_type == 'pick-up-at-counter') {
				this.setState({ selectRestaurantsModalOpen: false }, () => {
					this.props.dispatch(
						getIkentooMenusForLocation(
							restaurant.business_location_id,
							{
								pickTime: 'asap',
								json_time_selector: restaurant ? restaurant.pick_up_at_counter_json_time_selector : [],
							},
							false,
						),
					);
				});
			} else if (Basket.order_type == 'browse-menu') {
				this.setState({ selectRestaurantsModalOpen: false }, () => {
					this.props.dispatch(
						getIkentooMenusForLocation(
							restaurant.business_location_id,
							{
								pickTime: 'asap',
								json_time_selector: restaurant ? restaurant.browse_menu_json_time_selector : [],
							},
							restaurant.browse_menu_json_time_selector.length === 1 ? false : true,
						),
					);
				});
			} else if (Basket.order_type == 'charter-delivery') {
				this.setState({ selectRestaurantsModalOpen: false }, () => {
					this.props.dispatch(
						getIkentooMenusForLocation(restaurant.business_location_id, {
							pickTime: 'asap',
							json_time_selector: restaurant ? restaurant.charter_delivery_times_json : [],
						}),
					);
				});
			} else if (Basket.order_type == 'scheduled-delivery') {
				const pickTime = moment.unix(Basket.collection_time).tz(getConfig().timezone).format('HH:mm');
				this.setState({ selectRestaurantsModalOpen: false }, () => {
					this.props.dispatch(
						getIkentooMenusForLocation(restaurant.business_location_id, {
							pickTime,
							json_time_selector: [
								{
									menuId: restaurant?.active_menus.scheduled_delivery?.menu_id,
									availability: Object.keys(restaurant?.active_menus.scheduled_delivery?.slots).map((slot) => {
										if (restaurant?.active_menus.scheduled_delivery?.slots[slot].start_time) {
											return {
												d: weekdays[slot],
												start: restaurant?.active_menus.scheduled_delivery?.slots[slot].start_time,
												end: restaurant?.active_menus.scheduled_delivery?.slots[slot].end_time,
											};
										}
									}),
								},
							],
						}),
					);
				});
			} else if (Basket.order_type == 'scheduled-collection') {
				const pickTime = moment.unix(Basket.collection_time).tz(getConfig().timezone).format('HH:mm');
				this.setState({ selectRestaurantsModalOpen: false }, () => {
					this.props.dispatch(
						getIkentooMenusForLocation(restaurant.business_location_id, {
							pickTime,
							json_time_selector: [
								{
									menuId: restaurant?.active_menus.scheduled_collection?.menu_id,
									availability: Object.keys(restaurant?.active_menus.scheduled_collection?.slots).map((slot) => {
										if (restaurant?.active_menus.scheduled_collection?.slots[slot].start_time) {
											return {
												d: weekdays[slot],
												start: restaurant?.active_menus.scheduled_collection?.slots[slot].start_time,
												end: restaurant?.active_menus.scheduled_collection?.slots[slot].end_time,
											};
										}
									}),
								},
							],
						}),
					);
				});
			}
		});
	};
	titleClickHandler = () => {
		this.setState({ selectRestaurantsModalOpen: !this.state.selectRestaurantsModalOpen });
	};
	formatDataForSelect = () => {
		let formatedStores = [];
		this.props.restaurants.forEach((store) => {
			const orderType = Basket.order_type;
			let currentDT = moment.unix(Basket.collection_time).tz(getConfig().timezone);
			if (orderType == 'kiosk-table') {
				currentDT = moment().tz(getConfig().timezone);
			}
			let minDT = currentDT;

			const storeOpened = isStoreOpened(store);
			const snoozedTimes = checkSnoozedTimes(store, orderType);
			let slotsAvailable = [];
			store.isEnabled = storeOpened;
			if (orderType == 'kiosk-collection') {
				slotsAvailable = isTimeAvaibleInMenu(store.kiosk_json_time_selector, currentDT);
				store.opened = slotsAvailable;

				store.isEnabled = storeOpened && slotsAvailable;
				if (store.is_published && store.can_kiosk_collection_order && store.opened) {
					formatedStores.push(store);
				}
			} else if (orderType == 'kiosk-table') {
				const slotsAvailable = isTimeAvaibleInMenu(store.kiosk_table_json_time_selector, currentDT);
				store.isEnabled = storeOpened && slotsAvailable;
				store.opened = slotsAvailable;
				if (store.is_published && store.can_kiosk_table_order && store.isEnabled) {
					formatedStores.push(store);
				}
			}
		});
		return formatedStores;
	};
	generateTitle = (stores) => {
		return (<div className='multi-venue-restaurant-picker'>
			{stores.map(store => (
				<div onClick={() => this.selectMultiVenueRestaurant(store)} className={`${store.name == Basket.getRestauranName() ? 'store-selected' : ''}`}>{store.name}</div>
			))}
		</div>)
	}
	onSearchInputHandler = (val) => {
		this.filterMenuItems(val)
	}
	checkAvailableSlotsForToday = (restaurant) => {
		let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		let today = days[moment().format('d')];
		const day = {
			Monday: 'w1',
			Tuesday: 'w2',
			Wednesday: 'w3',
			Thursday: 'w4',
			Friday: 'w5',
			Saturday: 'w6',
			Sunday: 'w0',
		};
		let selectedRestaurant = restaurant
		let deliveryTimes = selectedRestaurant.charter_delivery_times_json;
		let flag = false;
		if (!isEmptyObject(deliveryTimes)) {
			for (let i = 0; i < deliveryTimes.length; i++) {
				deliveryTimes[i].availability.forEach((dt) => {
					if (dt.d === day[today]) {
						let addedTime = null;
						addedTime = moment().add(restaurant.charter_delivery_order_slot_lead_time, 'minutes');
						if (addedTime.isBefore(moment(dt.end, 'hh:mm'))) {
							flag = true;
						}
					}
				});
			}
		}

		return flag;
	};
	selectCategory = (category) => {
		this.setState({ selectedMenu: category })
	}
	breadCrumb = (name) => {
		let breadCrumb = name !== '' ? name + ' | ' : name;
		return breadCrumb;
	};

	subCategoriesList = (__, category, name) => {
		if (!isDefined(category)) {
			return <NoData />;
		}
		const categoryItems = category.menuEntry || category.menuEntryGroups || null;
		let items = this.itemList(__, categoryItems);
		let breadCrumb = this.breadCrumb(name);
		if (categoryItems) {
			return categoryItems.map((subCategory, index) => {
				if (subCategory['@type'] === 'group') {
					items = this.itemList(__, subCategory.menuEntry, index);
					const allGroup = subCategory.menuEntry.some((item) => item.type !== 'group');
					return this.drawCategoryItems(__, subCategory, items, breadCrumb, index, true, allGroup);
				} else {
					items = this.itemList(__, [subCategory], index);
					return this.drawCategoryItems(__, subCategory, items, name, index, false);
				}
			});
		}
		return this.drawCategoryItems(__, category, items, name, 0);
	};

	drawCategoryItems = (__, category, items, breadCrumb = null, i, isGroup = false, allGroup = false) => {
		let name = category.name ? breadCrumb + category.name : breadCrumb + '';
		let drawSubCategory = isGroup ? (
			<div className="menu-subitems" >
				<Subtitle className='menu-subitems-title'>{`${breadCrumb} ${Basket.getCategoryName(category, this.props.profile)}`}</Subtitle>
				{this.subCategoriesList(__, category, breadCrumb + category.name)}
			</div>
		) : (
			<>{items}</>
		);

		return <React.Fragment key={category.type + '_' + name + i}>{drawSubCategory}</React.Fragment>;
	};
	closeModal = () => this.setState({ modalOpen: false, modalItemOptions: defaultModalItemOptions, validationErrors: [] });
	showModal = (modalItem) => {
		this.setState(
			{
				modalItem,
				modalItemOptions: {
					...this.state.modalItemOptions,
					price: Basket._calculateItemPrice({ item: modalItem, quantity: 1 }),
					selectedChoices: modalItem.menuDealGroups && modalItem.menuDealGroups.length ? Array(modalItem.menuDealGroups.length).fill([]) : [],
					validationErrors: modalItem.menuDealGroups && modalItem.menuDealGroups.length ? Array(modalItem.menuDealGroups.length).fill(null) : [],
				},
				modalOpen: true,
			},

		);
	};
	itemList = (__, subCategoryItems, i) => {
		const { profile } = this.props;
		return (subCategoryItems || []).map((item, index) => {
			const selectedResturant = Basket.getRestaurant();
			let itemIsDisabled = false;
			if (selectedResturant && selectedResturant.disabled_skus && selectedResturant.disabled_skus.length > 0) {
				itemIsDisabled = selectedResturant.disabled_skus.includes(item.sku);
			}
			if (item.sku === undefined || itemIsDisabled) {
				return <></>;
			}
			let image = item.itemRichData && item.itemRichData.squareImageUrl ? item.itemRichData.squareImageUrl : '';
			if (image && image.indexOf('http://') !== -1) {
				image = image.replace(/http:\/\//g, 'https://');
			}
			const name = __(Basket.getProductName(item, profile));
			return (
				<div
					key={item.sku + '_' + index + i}
					title={name}
					className={`menu-item box-content  ${!Basket.isProductUnsnoozed(item) ? 'disabled-element' : ''} `}
					onClick={() => (Basket.isProductUnsnoozed(item) ? this.showModal(item) : null)}
				>
					{image && image !== '' ?
						<img className="menu-item-image" src={image} /> :
						<img className="menu-item-image" src={Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.clientProfile.logo_image} />

					}
					<div className="menu-item-info">
						<div style={{ flex: 1 }} className='menu-item-info-header'>
							<StrongText >{name}</StrongText>
							<StrongText className='primary-color'>{Basket.formatPrice(Basket.getProductCardPrice(item), true)}</StrongText>

						</div>
						{Basket.getProductDescription(item, profile) !== '' &&
							<div>
								<SmallText
									className='menu-item-info-description'
									dangerouslySetInnerHTML={{
										__html: Basket.getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, ''),
									}}
								></SmallText>
							</div>
						}
						<IonButton className='menu-item-button'>
							<IonIcon icon={addOutline} />
							{__('Add')}
						</IonButton>
					</div>
				</div>
			);
		});
	};
	showMultiVenueRestaurants = () => {
		this.setState({ multivenueRestaurantPickerOpened: !this.state.multivenueRestaurantPickerOpened })
	}
	menuRefs = (menuRefs) => {
		return menuRefs && menuRefs.menuEntryGroups
			? menuRefs.menuEntryGroups.reduce((acc, value, index) => {
				let name = `${value.name}_${index}`;
				acc[name] = React.createRef();
				return acc;
			}, {})
			: {};
	};
	selectCategoryOnScroll = (e) => {
		const scrollTop = Math.abs(e.target.scrollTop)
		e.preventDefault();
		const { menuRefs } = this.state;
		const positions = Object.keys(menuRefs).map((key) => {
			return menuRefs[key].current.offsetTop;
		});
		let selectCategory = 0;
		positions.forEach((item, i) => {
			if (item <= scrollTop) {
				selectCategory = i;
			}
		});

		this.setState({ selectedCategory: selectCategory, scrollTop: scrollTop });
	};
	scrollTo = (name) => this.state.menuRefs[name].current.scrollIntoView();

	render() {
		const { __, scrollTop, ikentooMenuError, profile } = this.props;
		const { selectedCategory, ikentooMenu, selectedMenu, modalOpen, modalItem, allergens } = this.state;
		let modalItemImage = modalItem && modalItem.itemRichData && modalItem.itemRichData.squareImageUrl ? modalItem.itemRichData.squareImageUrl : '';
		if (modalItemImage && modalItemImage.indexOf('http://') !== -1) {
			modalItemImage = modalItemImage.replace(/http:\/\//g, 'https://');
		}
		if (ikentooMenu?.ikentooMenuId !== this.props.ikentooMenu?.ikentooMenuId && this.props.ikentooMenu.ikentooMenuId) {
			this.setState({ ikentooMenu: this.props.ikentooMenu, originalMenu: this.props.ikentooMenu })
		}
		let categories = this.parseCategories({ selectedMenu, ikentooMenu });
		let formatedStores = this.formatDataForSelect();
		if (Basket.has_multi_basket && getConfig().flags.geolocationDisabled) {
			const stores = deepCopy(formatedStores);
			let openedRestaurants = stores.filter((store) => store.opened);
			let closedRestaurants = stores.filter((store) => !store.opened);
			openedRestaurants.sort((a, b) => {
				return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
			});
			openedRestaurants.sort((a, b) => a.sort_order - b.sort_order);
			closedRestaurants.sort((a, b) => {
				return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
			});
			closedRestaurants.sort((a, b) => a.sort_order - b.sort_order);
			formatedStores = [...openedRestaurants];
		}
		return (
			<Loading transparent>
				<Layout
					onSearchInputHandler={this.onSearchInputHandler}
					onSearchHandler={this.onSearchHandler}
					noPadding
					scrollY={false}
					backHandler={this.backHandler}
					color="transparent"
					onRestaurantClick={Basket.has_multi_basket ? this.showMultiVenueRestaurants : null}
					restaurantName={Basket.getRestaurant()?.name ?? ''}

				>
					<div className='absolute-content menu-page'>
						{this.state.multivenueRestaurantPickerOpened &&
							<div className='multivenue-restaurant-picker'>
								{formatedStores.map((store) => {
									return (
										<StrongText onClick={() => this.selectMultiVenueRestaurant(store)}>
											{store.name}
										</StrongText>
									);
								})}
							</div>
						}




						{ikentooMenuError ?
							<>
								<div className="order-content ">
									<NormalText className="no-items-message">{__('Oops, there was a problem with the menu. Please, try again.')}</NormalText>
								</div>
							</>
							: <>
								{!isDefined(ikentooMenu) ? null : (
									<div className={`menu-wrapper ${Basket.itemsCount() > 0 ? 'menu-wrapper-with-items' : ''}`}>
										<div style={{ display: 'flex', flexDirection: 'column' }} className='menu-categories'>
											<div style={{ overflow: 'auto', flex: 1 }}>
												{categories?.map((category, index) => {
													return (
														<div className={selectedCategory == index ? 'active menu-category' : 'menu-category'}
															onClick={() => this.scrollTo(`${category.name}_${index}`, index)}

														>

															<SmallText className='bold '>{Basket.getCategoryName(category, this.props.profile)}</SmallText>
														</div>
													);
												})}</div>
											{getConfig().kiosk.hasLoyalty &&
												<div
													onClick={() => {
														if (this.props.auth.loggedIn) {
															this.props.dispatch(setCommonProp('loyaltyModalOpen', true))
														} else {
															this.props.dispatch(setCommonProp('loginModalOpen', true))
														}
													}}
													className='loyalty-box box-content'>
													<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
														<path d="M2 15V17H18V15H2ZM2 4H4.2C4.11667 3.85 4.0625 3.69167 4.0375 3.525C4.0125 3.35833 4 3.18333 4 3C4 2.16667 4.29167 1.45833 4.875 0.875C5.45833 0.291667 6.16667 0 7 0C7.5 0 7.9625 0.129167 8.3875 0.3875C8.8125 0.645833 9.18333 0.966667 9.5 1.35L10 2L10.5 1.35C10.8 0.95 11.1667 0.625 11.6 0.375C12.0333 0.125 12.5 0 13 0C13.8333 0 14.5417 0.291667 15.125 0.875C15.7083 1.45833 16 2.16667 16 3C16 3.18333 15.9875 3.35833 15.9625 3.525C15.9375 3.69167 15.8833 3.85 15.8 4H18C18.55 4 19.0208 4.19583 19.4125 4.5875C19.8042 4.97917 20 5.45 20 6V17C20 17.55 19.8042 18.0208 19.4125 18.4125C19.0208 18.8042 18.55 19 18 19H2C1.45 19 0.979167 18.8042 0.5875 18.4125C0.195833 18.0208 0 17.55 0 17V6C0 5.45 0.195833 4.97917 0.5875 4.5875C0.979167 4.19583 1.45 4 2 4ZM2 12H18V6H12.9L15 8.85L13.4 10L10 5.4L6.6 10L5 8.85L7.05 6H2V12ZM7 4C7.28333 4 7.52083 3.90417 7.7125 3.7125C7.90417 3.52083 8 3.28333 8 3C8 2.71667 7.90417 2.47917 7.7125 2.2875C7.52083 2.09583 7.28333 2 7 2C6.71667 2 6.47917 2.09583 6.2875 2.2875C6.09583 2.47917 6 2.71667 6 3C6 3.28333 6.09583 3.52083 6.2875 3.7125C6.47917 3.90417 6.71667 4 7 4ZM13 4C13.2833 4 13.5208 3.90417 13.7125 3.7125C13.9042 3.52083 14 3.28333 14 3C14 2.71667 13.9042 2.47917 13.7125 2.2875C13.5208 2.09583 13.2833 2 13 2C12.7167 2 12.4792 2.09583 12.2875 2.2875C12.0958 2.47917 12 2.71667 12 3C12 3.28333 12.0958 3.52083 12.2875 3.7125C12.4792 3.90417 12.7167 4 13 4Z" fill="var(--ion-color-primary)" />
													</svg>
													<SmallText>{__('Loyalty & Rewards')}</SmallText>
												</div>
											}
										</div>
										<div style={{ overflow: 'auto' }}>
											<OrderList
												showModal={this.showModal}
												scrollTopPosition={scrollTop}
												selectCategoryOnScroll={this.selectCategoryOnScroll}
												category={!isEmptyObject(ikentooMenu) ? ikentooMenu : null}
												menuRefs={this.state.menuRefs ? this.state.menuRefs : []}
											></OrderList>
										</div>
										{Basket.itemsCount() > 0 ? (
											<div className='view-order-banner'>
												<div>
													<SmallText>{__('Current order')}</SmallText>
													<Spacer size={0} />
													<StrongText>{`${Basket.itemsCountAll()} ${Basket.itemsCountAll() == 1 ? __('item') : __('items')} • ${Basket._getTotal()}`}</StrongText>
												</div>
												<IonButton
													onClick={() => forwardTo('/checkout')}
													className="large-button"
												>
													{__('Go to checkout')}
													<IonIcon slot='end' icon={chevronForward} />
												</IonButton>

											</div>
										) : null}
									</div>
								)}

							</>}
					</div>
					{!Basket.table_name &&
						Basket.order_type === 'kiosk-table' &&
						getConfig().flags.hasTableNumberPicker && <TableNumberModal />}
					{modalOpen && (
						<Modal className="item-details-modal" isOpen={modalOpen} onDidDismiss={() => this.closeModal()}>
							{modalItem ? (
								<>
									<div className='item-details-wrapper'>
										<div className='item-details scrollable-wrapper'>

											{modalItemImage && modalItemImage !== '' ? (
												<img alt="modal item" src={modalItemImage} />
											) : (
												<img

													alt="modal item"
													src={Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.clientProfile.logo_image}
												/>
											)}
											<div className='item-details-content'>
												<Spacer size={0} />
												<Title className={'item-details-title'}>
													{__(Basket.getProductName(modalItem, this.props.profile))}
												</Title>

												{Basket.getProductDescription(modalItem, profile) !== '' &&
													<>
														<NormalText
															className="block item-details-card-description"
															dangerouslySetInnerHTML={{
																__html: Basket.getProductDescription(modalItem, profile).replace(/(<([^>]+)>)/gi, ''),
															}}
														></NormalText>
													</>
												}
												{Basket.formatPrice(modalItem.productPrice) &&
													<>
														<Spacer size={2} />
														<Subtitle className='primary-color'>{Basket.formatPrice(modalItem.productPrice)}</Subtitle>
													</>
												}
												<Spacer size={3} />

												<ItemDetailsRaw handleAlergens={this.handleAlergens} item={modalItem} profile={profile} modalOpen={modalOpen} closeModal={this.closeModal} />
											</div>

										</div>


									</div>

								</>
							) : null}
						</Modal>
					)}
				</Layout>
			</Loading>
		);
	}
}

const stateToProps = (state) => {
	const { clientProfile, navConfig, driverBookingPending, driverBookingMessage } = state.common;
	const { restaurants, ikentooMenu, defaultMenu, restaurantsUpdated, ikentooMenuError } = state.restaurants;
	const { scrollTop } = state.orders;
	const { profile, auth } = state.profile
	return {
		auth,
		restaurants: restaurants || [],
		ikentooMenu: ikentooMenu || {},
		defaultMenu: defaultMenu || {},
		basketUpdated: state.orders.basketUpdated,
		restaurantsUpdated,
		scrollTop,
		clientProfile,
		navConfig,
		driverBookingPending,
		driverBookingMessage,
		profile,
		ikentooMenuError
	};
};

export default connect(stateToProps)(withTranslation(OrderPage));
